module.exports = __webpack_public_path__ + "static/media/DL-Atomic-Design-web-01.162ae04b.jpg";